import { useContext } from 'react'
import SettingsContext from '../app/contexts/SettingsContext'
import type { SettingsContextValue } from '../app/contexts/SettingsContext'

const useSettings = (): SettingsContextValue => useContext(SettingsContext)

export default useSettings
